<template>
  <div class="flex h-[calc(100dvh-64px)] flex-col items-center justify-center gap-y-4">
    <h1 class="title">{{ title || t('errors.contentErrorTitle') }}</h1>
    <h2 class="subtitle mb-4 text-center">
      {{ subtitle || t('errors.contentErrorSubtitle') }}
    </h2>
    <RouterLink :to="{ name: routeName || 'FanzoneIndex' }">
      <Button>{{ buttonLabel || t('errors.backToFanzone') }}</Button>
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Button } from '@ui/button';

interface Props {
  title?: string;
  subtitle?: string;
  buttonLabel?: string;
  routeName?: string;
}

defineProps<Props>();
const { t } = useI18n();
</script>
